export default __webpack_public_path__ + "static/media/icon-happy-face-full.40341583.svg";